import Dropdown from "./Dropdown.vue";
import { pluginify } from "./../../util";
export default pluginify(Dropdown);
export { Dropdown };
